import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Email } from '../../../models/email';
import { SentEmailsLookup } from '../../../models/sent-emails-lookup';

export interface IEmailService {
  getEmailList(request: GetEmailListRequest): Observable<GetEmailListResponse>;

  getEmailById(request: GetEmailByIdRequest): Observable<GetEmailByIdResponse>;

  getEmailBody(request: GetEmailBodyRequest): Observable<GetEmailBodyResponse>;
}

export const EMAIL_SERVICE_TOKEN = new InjectionToken('Offers.IEmailService');

export class GetEmailListRequest {
  lookup: SentEmailsLookup;
}

export class GetEmailListResponse {
  entities: Array<Email> = new Array<Email>();
  totalItems: number;
}

export class GetEmailBodyRequest {
  emailId: string;
}

export class GetEmailBodyResponse {
  body: string;
}

export class GetEmailByIdRequest {
  emailId: string;
}

export class GetEmailByIdResponse {
  email: Email;
}
